//@flow
import * as React from "react";
import "./style.css";
import DefaultErrorPage from "../../../../Component/DefaultErrorPage";
type Props = {||};
type State = {||};

class FormNotFound extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }
  render() {
    return (
      <DefaultErrorPage
        disableButton={true}
        button="Create my Wispform"
        description="The form you are visiting does not exist. Please contact the form publisher for an updated URL."
        onButtonClick={() => {
          window.location.href = "https://www.wispform.com";
        }}
      />
    );
  }
}

export default FormNotFound;
